import axios from 'axios'
import Qs from 'qs'
import Vue from 'vue'
// import VueRouter from 'vue-router'
// import routers from './routers'
import 'vue-layer-mobile/need/layer.css'
import layer from 'vue-layer-mobile'
Vue.use(layer)
// Vue.use(VueRouter)
axios.defaults.timeout = 5000
axios.defaults.baseURL = 'https://s2.app.meyoutao.com';
// http request 拦截器
axios.interceptors.request.use(
  config => {
    // const token = getCookie('名称');注意使用的时候需要引入cookie方法，推荐js-cookie
    config.crossDomain = true;
    config.headers = {
      'X-Requested-With': 'XMLHttpRequest' ,
      'Content-Type': 'application/x-www-form-urlencoded'
    };
    config.xhrFields = {
      withCredentials: true
    };
    return config;
  },
  error => {
    return Promise.reject(err);
  }
);


//http response 拦截器
// axios.interceptors.response.use(
//   response => {
//     console.log(response)
//     console.log(response.data)
//     console.log(response.data.code == -9999)
//     if(response.data.code == -9998 || response.data.code == -9999 || response.code == -9998 || response.code == -9999){
//       //this.$store.state.sessionId = null
//       console.log(router);
//       layer.dialog({
//         content: response.data.errmsg
//         ,btn: ['登录']
//       }).then(function (res){
//         console.log(router);
//         window.location.href = window.location.href.split('#')[0] + '#' + '/login'
//       })
//     }else{
//       return response;
//     }
//   },
//   error => {
//     return Promise.reject(error)
//   }
// )


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function fetch(url,params={}){
  return new Promise((resolve,reject) => {
    axios.get(url,{
      params:params
    })
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err)
      })
  })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url,data = {}){
  // alert(url);
  // alert('data:' + JSON.stringify(data));
  return new Promise((resolve,reject) => {
    console.log(Qs.stringify(data))
    // alert('qsdata:' + Qs.stringify(data));
    const qsdata = Qs.stringify(data)
    var that = this
    axios.post(url,qsdata)
      .then(response => {
        // alert('response:' + response);
        resolve(response.data);
      },err => {
        //alert(err);
        reject(err)
        switch (err.response.status){
          case 500:
            layer.dialog({
              content: '服务器问题，请稍后再试'
              ,btn: ['确定']
            }).then(function (res){
              layer.close()
            });
            break;
        }
      })
  })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url,data = {}){
  return new Promise((resolve,reject) => {
    axios.patch(url,Qs.stringify(data))
      .then(response => {
        resolve(response.data);
      },err => {
        reject(err)
      })
  })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url,data = {}){
  return new Promise((resolve,reject) => {
    axios.put(url,Qs.stringify(data))
      .then(response => {
        resolve(response.data);
      },err => {
        reject(err)
      })
  })
}



// WEBPACK FOOTER //
// ./src/api.js